<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-intersect`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M46 5a2 2 0 00-2-2H16a2 2 0 00-2 2v9H4a2 2 0 00-2 2v26a2 2 0 002 2h28a2 2 0 002-2v-9h10a2 2 0 002-2V5zM6 18h8v13a2 2 0 002 2h14v7H6V18zm24 0H18v11h12V18zM18 7h24v22h-8V16a2 2 0 00-2-2H18V7z"/></svg>
</template>
<script>

export default {
  name: 'IconIntersect',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
